module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_3009.8f44eefe.png";